import './modules/avatar';
import './oldschool/toolbar_new';

import alertTpl from './views/alert.html';
import bisquit from './utils/cookie-handler';
import initLanguageSwitcher from './modules/language-switcher';
import initLinkedAccounts from './modules/linked-accounts';
import initAliases from './modules/aliases';
import mailBadgesInit from './modules/mail-badges';
import mailFetch from './utils/mail-fetch';
import mailPlusPromo, { MODAL_TYPE_ADBLOCK } from './modules/mailplus-promo';
import setCustomLogo from './modules/custom-logo';
import initThemeSwitcher from './modules/theme-switcher';

// global vars for fnErrorTrap (used in mail at least)
let js_context = null;
let js_now = new Date();
let js_started = Math.round(js_now.getTime() / 1000);


const fetchMailData = (INBOX, params) => {
    mailBadgesInit();
    mailFetch(INBOX, params);
};

const initToolbar = (INBOX, inx) => {
    const {
        params,
        sideMenu,
        toolBar: {
            selectors: tbSelectors
        }
    } = inx;
    const {
        mailHost,
        mapiHost,
        mapiFetchInterval,
        user
    } = params;
    // Defaults for mail fetching
    let mailFetchParams = {
        mailHost,
        mapiFetchInterval,
        mapiHost,
        userMail: user.email
    };

    return () => {
        setCustomLogo(tbSelectors.headerID, tbSelectors.siteLogo);
        if (user.email && user.email.length > 0) {
            // Set avatar
            // const avatar = INBOX.classes.Avatar();
            // avatar.check();
            var avatar1 = INBOX.classes.Avatar('.inx-profile__thumb');
            avatar1.check();

            // Fetch mail data and show mail badges

            //allow to select e-mail text without redirecting user to profile
            const navUserLink = document.querySelector('.nav-user a');

            if (navUserLink) {
                navUserLink.onclick = () => {
                    const cellText = document.getSelection();
                    if (cellText.type === 'Range') {
                        return false;
                    }
                };
            }

            if (typeof mailFetchParams.mailHost !== 'undefined') {
                const header = document.querySelector(tbSelectors.headerID);

                if (header && (
                    user.status === undefined
                    || user?.status?.trim() === ''
                    || ['open', 'trial'].includes(user.status)
                )) {
                    // console.log('fetchMailData called');
                    fetchMailData(INBOX, mailFetchParams);
                }
            }
        }

        // Initialize multi account module
        if (sideMenu?.linkedAccounts) {
            const mainUser = { email: user.email, name: user.name };
            initLinkedAccounts({ ...sideMenu, mapiHost, mainUser }, INBOX);
        }
        // Initialize aliases module
        if (sideMenu?.aliases) {
            const mainUser = { email: user.email, name: user.name };
            initAliases({ ...sideMenu, mapiHost, mainUser });
        }

        // Language switcher in the header
        initLanguageSwitcher(tbSelectors.langSwitch);
        initThemeSwitcher();
    };
};

((win) => {
    const { document: doc, INBOX, inx, inxBX } = win;
    const { ads, params } = inx;

    doc.addEventListener('DOMContentLoaded', initToolbar(INBOX, inx));

    // MAil+ promo modal
    if (typeof (inxBX) === 'object') {
        const { mailType, isSuper, project: { name: projectName, product: productName } } = params;

        //needed for banner system so it can show promo banner after showing some ad
        window.inx.ads.prodPromo = (params) => {
            const MaiPromoObj = mailPlusPromo({
                ...ads.assets,
                domain: window.inx?.params?.defaultDomain,
                sharedAssetsPath: inx.params.standard.path
            });

            const MaiPromoInstance = MaiPromoObj(inxBX, params);
            MaiPromoInstance.show();
        };

        const canShowAdblockModal = () => {
            //bannerka loaded correctly, do not show adblock modal
            if (inxBX.failed !== true) {
                return false;
            }
            //support (superuser) has impersonated user, do not show adblock modal
            if (isSuper) {
                return false;
            }
            //go.inbox.lv is landing page for premium users. do not show banner there
            if (productName === 'go') {
                return false;
            }
            //adblock modal is show only in portal and mail projects
            if (projectName !== 'portal' && projectName !== 'mail') {
                return false;
            }

            if (projectName === 'mail') {
                // Do not show adblock when "mailType" is not defined.
                // E.g. - error pages (400, 404, etc.)
                if (!mailType) return false;
                // Do not show for mail+ users
                if (mailType.isMailPlus) return false;
            }

            // Do not show Adblock modal in case of purchase modal
            const showPurchaseForm = window.location.search.includes('showPurchaseForm');
            if (showPurchaseForm) {
                return false;
            }

            //if user was logged in via this device for last 30 days as mail+ user
            //cookie is set in login for mail+ users in non-bizmail domains
            const mailPlusUserWasLoggedIn = bisquit.getIt('is_premium');
            if (mailPlusUserWasLoggedIn) {
                return false;
            }

            return true;
        };
        // Show "AdBlock detected" modal
        //do not show for superuser (support) and if user has mail+
        if (canShowAdblockModal()) {
            inx.ads.prodPromo({
                cookieName: 'adBlock-modal',
                i18n: inx.i18n.blockedAds,
                modalType: MODAL_TYPE_ADBLOCK,
                ttl: { close: 1800, later: 1800 } // 30 min. both
            });
        }
    }
})(window);

// Deprecated
window.inx.v6 = (() => {
    return {
        fnErrorTrap(sMsg, sUrl, sLine) {
            if (!window.enable_jserror_logging) {
                return true;
            }
            if (js_context) sUrl += '&JS_CONTEXT=' + js_context;
            var js_now = new Date();
            var url = '/jserror.php?error=JSERROR : ' + escape(sMsg) + '&line=' + sLine + '&sec=' + (Math.round(js_now.getTime() / 1000) - js_started) + '&method=GET&url=' + escape(sUrl) + '&rand=' + Math.random();
            var im = new Image();
            im.src = url;
            return true;
        },

        // TODO: Get rid of this method!
        showFlashMessage(type, message, append, containerID) {
            let template = document.querySelector('#alert-template'),
                opts = {
                    dismissible: true,
                    hasIcon: true,
                    text: message,
                    type: type || 'info'
                },
                container = document.querySelector('#flash-messages');

            if (container && template) {
                let newMessage = template.cloneNode(true);
                newMessage.innerHTML = newMessage.innerHTML.replace('%TYPE%', type).replace('%MESSAGE%', message);
                newMessage.removeAttribute('id');
                newMessage.style.display = 'block';

                if (!append) {
                    for (let i = 0; i < container.children.length; i++) {
                        if (container.children[i].id !== 'alert-template') {
                            container.removeChild(container.children[i]);
                        }
                    }
                }
                container.style.display = 'block';
                container.append(newMessage);
            }
            else {
                const customContainer = document.querySelector(containerID);
                customContainer.style.display = 'block';
                customContainer.innerHTML = alertTpl(opts);
            }
        }
    };
})();
